import { render, staticRenderFns } from "./RootLayout.vue?vue&type=template&id=4ee73368&scoped=true&"
import script from "./RootLayout.vue?vue&type=script&lang=js&"
export * from "./RootLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee73368",
  null
  
)

export default component.exports